import React, { useEffect, useRef, useState } from "react"
import { labels } from "../../../../../constants/label.constants"
import {
  gaLogo,
  gaLogoLabel,
  gaMenuClick,
} from "../../../../../constants/gtm.constants"
import PropTypes from "prop-types"
import * as styles from "./Navigation-tw-styles"
import Link from "../../../../UI/Link/Link"
import useImage from "../../../../../hooks/useImage"
import Image from "../../../../UI/Image/Image"

const Navigation = ({ navigation, logoImg, variant }) => {
  const style = styles[variant] || styles.defaultStyle
  const { navContainer, mainNavigation } = style

  let [childNavLinks, setChildNavLinks] = useState([])
  let [secondChildNavLinks, setSecondChildNavLinks] = useState([])
  let [thirdChildNavLinks, setThirdChildNavLinks] = useState([])
  const [toggledFirstChildId, setToggledFirstChildId] = useState("")
  const [toggledChildId, setToggledChildId] = useState()
  const [secondtoggledChildId, setSecondToggledChildId] = useState()

  const { altText, foregroundImg } = useImage(logoImg)
  const [dropdown, setDropdown] = useState(false)
  const ref = useRef()
  const contentEl = useRef(null)
  const contentEl2 = useRef(null)

  const handleFirstSubmenu = (items, index) => {
    setChildNavLinks(items)
    if (toggledFirstChildId === "") {
      setDropdown(prev => !prev)
      setToggledFirstChildId(index)
    } else if (toggledFirstChildId === index) {
      setDropdown(prev => !prev)
      setToggledFirstChildId("")
    } else {
      setDropdown(false)
      setTimeout(() => {
        setDropdown(true)
      }, 700)
      setToggledFirstChildId(index)
    }
  }

  const handleSecondSubmenu = (items, index) => {
    setThirdChildNavLinks([])
    setSecondChildNavLinks(items)
    setToggledChildId(index)
  }
  const handleThirdSubmenu = (items, index) => {
    setThirdChildNavLinks(items)
    setSecondToggledChildId(index)
  }

  const handleAriaLabel = (dropdown,toggledFirstChildId, index, label ) =>{
    let display = dropdown && toggledFirstChildId === index
                        ? "expanded"
                        : "collapsed";
    return `${label}-${display}`
    
  }

  useEffect(() => {
    return () => {
      setSecondChildNavLinks([])
      setThirdChildNavLinks([])
      setToggledChildId()
      setSecondToggledChildId()
    }
  }, [childNavLinks])

  useEffect(() => {
    const handler = event => {
      if (dropdown && ref.current && !ref.current.contains(event.target)) {
        setDropdown(false)
      }
    }
    document.addEventListener("mousedown", handler)
    document.addEventListener("touchstart", handler)
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", handler)
      document.removeEventListener("touchstart", handler)
    }
  }, [dropdown])

  return (
    <div className={style?.mainNavWrap} ref={ref}>
      <div className={style?.mainNavInwrap}>
        <div className={style?.brandLogo}>
          <Link
            url={labels?.urls?.homepage}
            ariaLabel={labels?.header?.logo?.ariaLabel}
            role={labels?.header?.logo?.role}

          >
            <Image
              className={style?.logoImgs}
              contentfulImage={foregroundImg}
              alt={altText}
              width={labels?.header?.logo?.width}
              height={labels?.header?.logo?.height}
              eventClass={gaLogo}
              eventLabel={gaLogoLabel}
            />
          </Link>
        </div>
        <div className={navContainer}>
          <ul className={mainNavigation}>
            {navigation?.length > 0 &&
              navigation?.map((item, index) => {
                return (
                  <li
                    key={index}
                    className={
                      dropdown && toggledFirstChildId === index
                        ? "activMain"
                        : ""
                    }
                  >
                    <Link
                      {...item?.link}
                      onClick={() =>
                        handleFirstSubmenu(item?.dropdownItems, index)
                      }
                      url={"#"}
                      gaEventClass={gaMenuClick}
                      gaEventLabel={item?.label}
                      linkrole="button"
                      ariaLabel={handleAriaLabel(dropdown,toggledFirstChildId,index,item?.label) }
                    >
                      {item?.label}
                    </Link>
                  </li>
                )
              })}
          </ul>
        </div>
      </div>
      <div
        className={
          dropdown
            ? `show ${style?.megaNavWrap}`
            : `hideMenu ${style?.megaNavWrap}`
        }
      >
        <div className={style?.megaNavWrapInwrap} ref={contentEl}>
          <div className={style?.megablandiv}></div>
          <ul className={style?.megadivOne}>
            {childNavLinks?.map((item, index) => {
              return (
                <li
                  key={index}
                  className={`${
                    toggledChildId === index
                      ? `${style?.megadivOneIN} active`
                      : `${style?.megadivOneIN}`
                  }`}
                >
                  <Link
                    {...item.link}
                    className={item?.dropdownItems === null ? "notsubMenu" : ""}
                    onClick={() =>
                      handleSecondSubmenu(item?.dropdownItems, index)
                    }
                    tabIndex={0}
                    gaEventClass={gaMenuClick}
                    gaEventLabel={item?.label}
                    ariaLabel={item?.label}
                    linkrole="button"
                  >
                    {item?.label}
                    <span
                      className={`${
                        toggledChildId === index
                          ? "MenuRightArrow active"
                          : "MenuRightArrow"
                      }`}
                    ></span>
                  </Link>
                </li>
              )
            })}
          </ul>

          <ul
            className={`${
              secondChildNavLinks?.length > 0 && dropdown ? " show" : "hide"
            } ${style?.megadivTwo}`}
            ref={contentEl2}
          >
            {secondChildNavLinks?.length > 0 &&
              dropdown &&
              secondChildNavLinks?.map((item, index) => {
                return (
                  <li
                    key={index}
                    className={`${
                      secondtoggledChildId === index
                        ? `${style?.megadivTwoIN} active`
                        : `${style?.megadivTwoIN}`
                    }`}
                  >
                    <Link
                      {...item.link}
                      onClick={() =>
                        handleThirdSubmenu(item?.dropdownItems, index)
                      }
                      className={
                        item?.dropdownItems === null ? "notsubMenu" : ""
                      }
                      gaEventClass={gaMenuClick}
                      gaEventLabel={item?.label}
                      linkrole="button"
                    >
                      {item.label}
                      <span
                        className={`${
                          secondtoggledChildId === index
                            ? "MenuRightArrow active"
                            : "MenuRightArrow"
                        }`}
                      ></span>
                    </Link>
                  </li>
                )
              })}
          </ul>
          <div className={style.ThirdLevelMain}>
            {thirdChildNavLinks?.length > 0 &&
              thirdChildNavLinks?.map((item, index) => {
                return (
                  <li key={index}>
                    <Link
                      {...item?.link}
                      gaEventClass={gaMenuClick}
                      gaEventLabel={item?.label}
                    >
                      {item?.label}
                    </Link>
                  </li>
                )
              })}
          </div>
        </div>
      </div>
    </div>
  )
}

Navigation.propTypes = {
  navigation: PropTypes.array,
  logoImg: PropTypes.object,
  variant: PropTypes.string,
}

export default Navigation